<template>
  <div>
    <v-text-field
      v-model="local.imageUrl"
      label="URL da imagem"
      outlined
      dense
      hint="A imagem é enviada para o bucket e usada no header de todos os disparos"
      persistent-hint
      class="mb-2"
      @input="emitChange"
    />
    <v-file-input
      accept="image/*"
      label="Enviar imagem"
      outlined
      dense
      prepend-icon=""
      prepend-inner-icon="mdi-image"
      :loading="uploading"
      @change="onUpload"
    />

    <div class="text-caption mb-1">Corpo</div>
    <v-textarea
      ref="body"
      v-model="local.body"
      outlined
      auto-grow
      rows="4"
      counter="1024"
      @input="emitChange"
    />
    <v-chip small class="mb-4" @click="insertVariable">
      {{ variableLabel }}
    </v-chip>

    <v-text-field
      v-model="local.footer"
      label="Rodapé"
      outlined
      dense
      counter="60"
      @input="emitChange"
    />

    <div class="d-flex align-center mb-2">
      <div class="text-subtitle-2">Botões</div>
      <v-spacer />
      <v-btn small text :disabled="local.buttons.length >= 3" @click="addButton('QUICK_REPLY')">
        Resposta rápida
      </v-btn>
      <v-btn small text :disabled="urlCount >= 2 || local.buttons.length >= 3" @click="addButton('URL')">
        Link
      </v-btn>
    </div>
    <div v-for="(btn, index) in local.buttons" :key="'btn-' + index" class="d-flex mb-2">
      <v-text-field
        v-model="btn.text"
        :label="btn.type === 'URL' ? 'Texto do link' : 'Resposta rápida'"
        outlined
        dense
        hide-details
        class="mr-2"
        @input="emitChange"
      />
      <v-text-field
        v-if="btn.type === 'URL'"
        v-model="btn.url"
        label="https://"
        outlined
        dense
        hide-details
        class="mr-2"
        @input="emitChange"
      />
      <v-btn icon @click="removeButton(index)"><v-icon>mdi-close</v-icon></v-btn>
    </div>

    <div class="text-caption text--secondary mb-2 mt-4">Pré-visualização</div>
    <whatsapp-preview
      :body-html="previewBody"
      :footer="local.footer"
      :image-url="local.imageUrl || null"
      :buttons="previewButtons"
    />
  </div>
</template>

<script>
import WhatsappPreview from "@/components/admin/messager/WhatsappPreview.vue";

const VARIABLE = "{{user.firstName}}";

export default {
  components: { WhatsappPreview },
  props: {
    value: { type: Object, default: () => ({}) },
    uploadFile: { type: Function, required: true },
  },
  data() {
    return {
      variableLabel: VARIABLE,
      uploading: false,
      local: this.blank(this.value),
    };
  },
  computed: {
    urlCount() {
      return this.local.buttons.filter((btn) => btn.type === "URL").length;
    },
    previewButtons() {
      return this.local.buttons.map((btn) => btn.text).filter(Boolean);
    },
    previewBody() {
      const escaped = String(this.local.body || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/\n/g, "<br>")
        .replace(/\*([^*]+)\*/g, "<b>$1</b>");
      return escaped.replace(/\{\{\s*user\.firstName\s*\}\}/g, "<b>Maria</b>");
    },
  },
  methods: {
    blank(value) {
      const source = value || {};
      return {
        imageUrl: source.imageUrl || "",
        body: source.body || "",
        footer: source.footer || "",
        buttons: Array.isArray(source.buttons)
          ? source.buttons.map((btn) => ({ ...btn }))
          : [],
      };
    },
    emitChange() {
      this.$emit("input", {
        imageUrl: this.local.imageUrl,
        body: this.local.body,
        footer: this.local.footer,
        buttons: this.local.buttons.map((btn) => ({ ...btn })),
      });
    },
    insertVariable() {
      const field = this.$refs.body?.$refs?.input;
      const current = this.local.body || "";
      if (!field) {
        this.local.body = `${current}${VARIABLE}`;
      } else {
        const start = field.selectionStart || current.length;
        const end = field.selectionEnd || start;
        this.local.body = current.slice(0, start) + VARIABLE + current.slice(end);
      }
      this.emitChange();
    },
    addButton(type) {
      this.local.buttons.push(type === "URL" ? { type, text: "", url: "" } : { type, text: "" });
      this.emitChange();
    },
    removeButton(index) {
      this.local.buttons.splice(index, 1);
      this.emitChange();
    },
    async onUpload(file) {
      const selected = Array.isArray(file) ? file[0] : file;
      if (!selected) return;
      this.uploading = true;
      try {
        const result = await this.uploadFile(selected);
        this.local.imageUrl = result.url;
        this.emitChange();
      } finally {
        this.uploading = false;
      }
    },
  },
};
</script>
